function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Strong } from '@finect/tabular-core/Strong';
import { Link } from 'react-router-dom';
import { getProductName, getFundClassName, getProductPath, getProductReviewPath, getProductTypeById } from '@finect/front-resources/Products';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getAuthorPath } from '../../Articles/utils';
import { Tooltip } from '../../Tooltip';
import { Icon } from '../../Icon';
import { Image } from '../../Image';
import { Rating } from '../../Rating';
import { ReviewBlock, ReviewInfo, ProductName, ReviewTitle, AnswerBlock, AnsweredBy, Adviser, AdviserCompany } from './partials';
export var ReviewCute = function ReviewCute(_ref) {
  var review = _ref.review,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'client' : _ref$type,
    _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? true : _ref$lazyLoad;
  if (type === 'quote') {
    var _title = review.title,
      _author = review.author;
    return React.createElement(ReviewBlock, {
      quote: true
    }, React.createElement(ReviewInfo, null, React.createElement(ReviewTitle, null, "\"", _title, "\"")), React.createElement(AnswerBlock, null, React.createElement(AnsweredBy, {
      align: "center"
    }, React.createElement(Icon, {
      size: 2,
      alt: _author.displayName,
      image: _author.icon,
      lazyLoad: lazyLoad
    }), React.createElement(Adviser, null, React.createElement(Strong, null, _author.displayName), React.createElement(AdviserCompany, null, _author.position)), _author.organizationIcon && React.createElement(Image, {
      src: _author.organizationIcon,
      alt: _author.organization,
      w: 120
    }))));
  }
  if (type === 'voces') {
    var _title2 = review.title,
      _author2 = review.author,
      link = review.link;
    return React.createElement(ReviewBlock, _extends({
      voces: true
    }, link ? _objectSpread(_objectSpread({}, link), {}, {
      as: AppLink
    }) : {}), React.createElement(ReviewInfo, null, React.createElement(ReviewTitle, null, _title2)), React.createElement(AnswerBlock, null, React.createElement(AnsweredBy, {
      align: "center"
    }, React.createElement(Icon, {
      size: 2,
      alt: _author2.displayName,
      image: _author2.icon,
      lazyLoad: lazyLoad
    }), React.createElement(Adviser, null, React.createElement(Strong, null, _author2.displayName), React.createElement(AdviserCompany, null, _author2.position)), _author2.organizationIcon && React.createElement(Image, {
      src: _author2.organizationIcon,
      alt: _author2.organization,
      h: 45,
      w: 100
    }))));
  }
  var title = review.title,
    author = review.author,
    product = review.product,
    score = review.score;
  var _author$organizations = _slicedToArray(author.organizations, 1),
    company = _author$organizations[0];
  var authorPath = getAuthorPath(author);
  var authorHasProfile = author.subtype === 'user' && author.features && author.features.includes('profile');
  var authorNameProps = authorHasProfile ? {
    href: authorPath,
    as: type === 'client' ? AppLink : 'a',
    title: "Ir al perfil de ".concat(author.displayName)
  } : {};
  var productName = getFundClassName(product.entity) || getProductName(product.entity, getProductTypeById(product.subtype));
  var productNameProps = {
    to: getProductPath({
      subtype: product.subtype,
      entity: _objectSpread({}, product.entity)
    }),
    as: type === 'client' ? Link : 'a',
    title: "Ir a la ficha de ".concat(productName)
  };
  var reviewPath = getProductReviewPath(product, review);
  var reviewPathProps = {
    to: reviewPath,
    as: type === 'client' ? Link : 'a',
    title: "Ver review completa de ".concat(productName)
  };
  return React.createElement(ReviewBlock, null, React.createElement(ReviewInfo, null, React.createElement(Tooltip, {
    from: "left",
    width: "290px",
    tip: product.entity.displayName
  }, React.createElement(AppLink, productNameProps, React.createElement(ProductName, null, productName))), React.createElement(Rating, {
    size: "small",
    value: score,
    isSelectable: false,
    starSize: "16px",
    type: "infoStar"
  }), React.createElement(AppLink, reviewPathProps, React.createElement(ReviewTitle, null, title))), React.createElement(AnswerBlock, null, React.createElement(AnsweredBy, {
    align: "center"
  }, React.createElement(Icon, {
    alt: author.displayName,
    image: author.icon,
    type: company ? 'user' : 'company',
    lazyLoad: lazyLoad
  }), React.createElement(Adviser, null, React.createElement(Strong, authorNameProps, author.displayName), company ? React.createElement(AdviserCompany, null, company.displayName) : null))));
};